import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
